import React, {useEffect} from "react";
import classes from "./GoGoBag.module.scss";
import Heading from "../../../components/caseStudy/heading/Heading.tsx";
import Info, {Feature, Topic} from "../../../components/caseStudy/info/Info.tsx";
import logo from "./media/logo.svg";
import OtherProjects from "../../../components/caseStudy/other-projects/OtherProjects.tsx";
import {ECaseStudy} from "../../../enums/case-study.enum.ts";
import {useTranslation} from "react-i18next";
import OrganizationSeo from "../../../components/Seo/OrganizationSeo.tsx";


const GoGoBag = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const {t} = useTranslation();

    const title = [t('goGoBag.title'), t('goGoBag.blueTitle')]
    
    const description = t('goGoBag.text', {returnObjects: true})
    

    const infoTitle = t('goGoBag.info.title');

    const infoTitleMessage = t('goGoBag.info.text')
    const topics: Topic[] = t('goGoBag.topic', {returnObjects: true})

    const features: Feature = {
        title: t('goGoBag.featuresText'),
        extendedList: t('goGoBag.featuresList', {returnObjects: true})
    }

    const results = {
        title: t('goGoBag.results.title'),
        ul: t('goGoBag.results.ul', {returnObjects: true})
    }

    const rightBlock = {
    platforms: t('goGoBag.rightBlock.platforms', {returnObjects: true}),
    services: t('goGoBag.rightBlock.services', {returnObjects: true}),
    audience: t('goGoBag.rightBlock.audience', {returnObjects: true}),
    field: t('goGoBag.rightBlock.field', {returnObjects: true})
    }

    return (
        <>
            <OrganizationSeo
                title="Goteco: Secure and Scalable GovTech and Business Solutions"
                description="Goteco specializes in developing secure, scalable systems that boost efficiency across public and private sectors, optimizing processes in manufacturing, e-commerce, and construction industries."
                url="https://go-te.co/"
                image="https://go-te.co/logo.svg"
            />

            <section className={classes.section} id="nav-dark">
                <Heading title={title} description={description} maxWidth={800} imageName={'go-go-bag.webp'} imageHeight={593} imageWidth={544} buttonText={t('goGoBag.buttonText')} href={"https://gogobag.eu/en"}/>
                <Info title={infoTitle} titleMessage={infoTitleMessage} topics={topics} features={features}
                      rightBlock={rightBlock} results={results}/>

                <div className={classes["image-section"]}>
                    <div className={classes["overlay"]}></div>
                    <div className={classes["image-container"]}>
                        <img className={classes.logo} src={logo} alt="Cybertracker logo"/>
                        <div className={classes.text}>
                            {t('goGoBag.bottomText')}
                            <span>
                                {t('goGoBag.bottomText2')}
                            </span>
                        </div>
                    </div>
                </div>

                <OtherProjects name={ECaseStudy.GO_GO_BAG}/>
            </section>
        </>

    );
};

export default GoGoBag;
